import {h, Fragment} from "preact"
/* Nosto Face */
import { useFacet } from "@nosto/preact";
import { useState, useEffect } from "preact/hooks";
import { CheckboxV2 as Checkbox } from "../elements/";
import FacetPanel from './FacetPanel'
import Facets from "../elements/facetsData";
import { useCustomConfig } from "../../hooks/useCustomConfig"

export default function Facet({ facetIn }) {
    const [facet, setFacet] = useState();
    
    const [showAll, setShowAll] = useState(false);
    const { toggleProductFilter } = useFacet(facetIn);
    const { customConfig } = useCustomConfig()

    const initialVisibleCount = customConfig.filters.visibleItems;

    useEffect(() => {
        const sortWashFilters = (filters, name) => {
            if (!filters?.length || filters.length < 2) return null;

            const facetsDataFilter = Facets.find(data => data.name === name);
            if (!facetsDataFilter) return null;

            return filters.sort((a, b) => {
                const iA = facetsDataFilter.values.indexOf(a.value);
                const iB = facetsDataFilter.values.indexOf(b.value);
                return iA === -1 ? 1 : iB === -1 ? -1 : iA - iB;
            });
        };

        if (facetIn?.data && facetIn.name) {
            const sortedData = sortWashFilters(facetIn.data, facetIn.name);
            if (sortedData) {
                setFacet({ ...facetIn, data: sortedData });
            } else {
                setFacet(facetIn);
            }
        }
    }, [facetIn]);

    if (!facet) return null; 

    //const visibleItems = showAll ? facet.data : facet.data?.slice(0, initialVisibleCount);
    const visibleItems = showAll 
    ? facet.data.filter(value => value.count > 0)
    : facet.data.filter(value => value.count > 0).slice(0, initialVisibleCount);

    return (
        <FacetPanel 
            panelName={facet.name} 
            showMoreButton={facet.data?.length > initialVisibleCount} 
            onShowAllClick={() => setShowAll(!showAll)}
            showAll={showAll}>
            {visibleItems?.map((value) => (
                <div
                    className="item"
                    data-nosto-element="facet-setting"
                >
                    <Checkbox
                        value={value.value}
                        selected={value.selected}
                        onChange={(e) => {
                            e.preventDefault();
                            toggleProductFilter(facet.field, value.value, !value.selected);
                        }}
                    />
                    {customConfig.filters.showProductCount && <span className="">({value.count})</span>}
                </div>
            ))}
        </FacetPanel>
    );
}
